<template>
    <div class="vue-area-manager-placeholder">
        <div class="avatar-picture">
            <img src="/themes/custom/ef2_custom/images/placeholder-areamanager.png">
        </div>

        <div class="content-wrapper text-center">
            <p>{{ placeholdText }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "AreaManagerPlaceholder",

    props: {
        placeholdText: {
            type: String,
        }
    },
}
</script>